'use strict';
var $ = require('../internals/export');
var $filterOut = require('../internals/array-iteration').filterOut;
var addToUnscopables = require('../internals/add-to-unscopables');

// `Array.prototype.filterOut` method
// https://github.com/tc39/proposal-array-filtering
$({ target: 'Array', proto: true }, {
  filterOut: function filterOut(callbackfn /* , thisArg */) {
    return $filterOut(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

addToUnscopables('filterOut');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/esnext.array.filter-out.js
// module id = 931
// module chunks = 1 2 3 4